import TextEditor from './textEditor';

export default TextEditor;
